 <template>
    <v-card class="flex pa-0 background-2 round-card" v-if="!$store.getters.progress">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Andamento Fatturato Clienti</p>
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="$eventBusUtility.exportCSV(headers, items, 'Andamento fatturato clienti')" icon :disabled="items.length == 0">
                        <v-icon color="grey darken-1">play_for_work</v-icon>
                    </v-btn>
                </template>
                <span>Esporta CSV</span>
            </v-tooltip>                                  
        </v-card-title>                
        <v-divider></v-divider>
        <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
            <fields-generator
                class="pt-4"
                :fieldsset.sync="fieldsset"
                :model="model"
                ref="fieldsgenerator"
            ></fields-generator>

            <v-data-table
                class="background-2"
                :items="items"
                :headers="headers"
                :loading="loading"
                :footer-props="{
                    'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
                }">

                <template v-slot:item="props">
                    <tr class="cursor-pointer">
                        <td>
                            {{ props.item['name'] }}
                        </td>
                        <td>
                            <strong>
                                {{ props.item['total'] | currency }}
                            </strong>
                        </td>
                        <td v-if="$store.getters.checkModelPermissions('commercial')">
                            {{ props.item['commission'] | currency }}
                        </td>                                     
                        <td>
                            {{ props.item['cost'] | currency }}
                        </td>                                    
                        <td v-if="$store.getters.checkModelPermissions('commercial')">
                            {{ props.item['shipping_margin'] | currency }}
                        </td>                                    
                        <td>
                            {{ props.item['margin'] | currency }}
                        </td>
                        <td style="border-left: 1px solid rgba(0,0,0,0.12)">
                            <strong>
                                {{ props.item['total_1'] | currency }}
                            </strong>

                        </td>                                    
                        <td v-if="$store.getters.checkModelPermissions('commercial')">
                            {{ props.item['commission_1'] | currency }}
                        </td>
                        <td>
                            {{ props.item['cost_1'] | currency }}
                        </td>
                        <td v-if="$store.getters.checkModelPermissions('commercial')">
                            {{ props.item['shipping_margin_1'] | currency }}
                        </td>
                        <td>
                            {{ props.item['margin_1'] | currency }}
                        </td>
                        <td class="text-center">
                            <span v-if="props.item['total'] > 0 && props.item['total_1'] == 0" class="success--text">
                                <v-icon color="success">trending_up</v-icon>                                            
                            </span>                                        
                            <span v-else-if="props.item['trend'] > 0" class="success--text">
                                + {{ props.item['trend']}} %
                                <v-icon color="success">trending_up</v-icon>                                            
                            </span>
                            <span v-else-if="props.item['trend'] < 0" class="error--text">
                                    {{ props.item['trend']}} %
                                <v-icon color="error">trending_down</v-icon>
                            </span>
                            <span v-else>
                                <v-icon color="info">trending_flat</v-icon>                                            
                            </span>
                        </td>
                    </tr>
                </template>
                <template v-slot:footer.page-text="{ pageStart, pageStop }">
                    Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                </template>                
            </v-data-table>
        </v-container>

        <v-slide-y-reverse-transition>

            <v-footer 
                v-show="showFooter" 
                height="auto" 
                class="background-2 elevation-10" 
                fixed 
                app 
                transition="slide-x-transition">
                <v-container class="py-2" fluid>

                    <v-row  justify="center">
                        <v-col class="pa-0" lg="2" md="2" sm="6" >                       
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Fatturato A</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.totalrow | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Provvigione A</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.commission | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>    
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Costi A</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.cost | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                               
                        <v-col class="pa-0" lg="2" md="2" sm="6" >                           
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Costi di spedizione A</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.shipping_margin | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Margine A</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.margin | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                               

                    </v-row>
                    <v-divider></v-divider>                 
                    <v-row  justify="center">
                        <v-col class="pa-0" lg="2" md="2" sm="6" >                       
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Fatturato B</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.totalrow_1 | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Provvigione B</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.commission_1 | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>    
                        <v-col class="pa-0" lg="2" md="2" sm="6" >                           
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Costi B</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.cost_1 | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Costi di spedizione B</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.shipping_margin_1 | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                               
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="background-2 w100p pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">mdi-currency-eur</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Margine B</v-list-item-title>
                                        <v-list-item-subtitle>{{ totals.margin_1 | currency }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>       
                        </v-col>                               

                    </v-row>
                </v-container>
            </v-footer>
        </v-slide-y-reverse-transition>
        <v-fab-transition>
            <v-btn
                color="primary"
                v-model="showFooter"
                dark
                fab
                fixed
                bottom
                right
                @click="showFooter = !showFooter"
                >
                <v-icon v-if="showFooter">expand_more</v-icon>
                <v-icon v-else>expand_less</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-card>
</template>

<script>
	import Vue from 'vue'

    export default {
        name: 'sales-trend',    
        props: {
			url: {
				type: String,
				default: 'salestrend'
            }
        },
        data() {
            return {
                fieldsset: {},
                headers: [],
                model: {
                    from: moment().startOf('month').format('YYYY-MM-DD'),
                    to: moment().endOf('month').format('YYYY-MM-DD'),                   
                    from_1: moment().startOf('month').subtract(1, 'years').format('YYYY-MM-DD'),
                    to_1: moment().endOf('month').subtract(1, 'years').format('YYYY-MM-DD'),
                },
                loaded: false,
                items: [],
                datepicker_menu: {},
                loading: false,
                totals: {
                    totalrow: 0,
                    commission: 0,
                    cost: 0,
                    shipping_margin: 0,
                    margin: 0,
                    totalrow_1: 0,
                    cost_1: 0,
                    shipping_margin_1: 0,
                    commission_1: 0,
                    margin_1: 0,
                },
                showFooter: true,
                totalItems: 0,                
            }
        },

        created() {
            this.axios.get(this.url + '-info').then(response => {
                // get body data
                this.fieldsset = response.data.info.fields
                this.headers = response.data.info.headers

                _.forEach(this.fieldsset, (value, key) => {
                    if(value.default) {
                        Vue.set(this.model, value.key, value.default)
                    }
                })

                this.getData()

                this.$store.commit('endProgress')


            }, response => {
                // error callback
            })
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            }
        },

        methods: {

            getData() {

                this.loading = "warning"

                this.axios.post(this.url, this.model).then(response => {
                    this.items = response.data.data.result
                    this.totalItems = response.data.data.result.length
                    this.totals = response.data.data.totals
                    this.loading = false

                }, response => {
                    // error callback
                })
            },
        },
    }
</script>